export default "https://sdk.cotreat.ai/flags@2x-140042eb.png";